/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addacoverimagetopublish5Inputs */

const en_addacoverimagetopublish5 = /** @type {(inputs: Addacoverimagetopublish5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add an image to publish.`)
};

const de_addacoverimagetopublish5 = /** @type {(inputs: Addacoverimagetopublish5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füg ein Bild hinzu, um zu veröffentlichen.`)
};

/**
* | output |
* | --- |
* | "Add an image to publish." |
*
* @param {Addacoverimagetopublish5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const addacoverimagetopublish5 = /** @type {((inputs?: Addacoverimagetopublish5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addacoverimagetopublish5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addacoverimagetopublish5(inputs)
	return de_addacoverimagetopublish5(inputs)
});
export { addacoverimagetopublish5 as "addACoverImageToPublish" }